export { default as Profile } from "./private/profile";
export { default as Home } from "./private/home";
export { default as ContactDetails } from "./private/contactDetails";
export { default as PersonalInformation } from "./private/personalInformation";
export { default as UpdateEmail } from "./private/updateEmail";
export { default as ResendUpdateEmail } from "./private/resendUpdateEmail";
export { default as ChangePassword } from "./private/changePassword";
export {
  default as TestResultPage,
  TestResultDetailsPage,
  TestResultPdfPage,
  DetailRecordPage,
  TestInformationPage,
  UnderstandingYourResultsPage,
  ShareFetalSexPage,
  DownloadableResultsGuidePage,
} from "./private/testResult";
export { default as SampleDraw } from "./private/sampleDraw";
export { default as TestHistory } from "./private/testHistory";
export { default as Feedback } from "./private/feedback";
export { default as BillingCenter } from "./private/billingCenter";
export { default as SimpleOrder } from "./private/simpleOrder";
export { default as CommunicationPreferences } from "./private/communicationPreferences";
export { default as VideoPage } from "./private/videoPage";
export { default as NoContentView } from "./private/noContentView";
export { default as Activation } from "./public/activation";
export { default as SetPassword } from "./public/setPassword";
export { default as LogOut } from "./public/logOut";
export { default as BillingEstimate } from "../preBill/pages/private/billingEstimate";
export { default as NonCoveredService } from "../preBill/pages/private/nonCoveredService";
export { default as OutOfNetwork } from "../preBill/pages/private/outOfNetwork";
export { default as PriorAuthorization } from "../preBill/pages/private/priorAuthorization";
export { default as GuestLogin } from "../preBill/pages/public/guestLogin";
export { default as NoLongerAvailable } from "../preBill/pages/public/noLongerAvailable";
export { default as InsuranceNoLongerAvailable } from "../preBill/pages/public/insuranceNoLongerAvailable";
export { default as BillingUpdates } from "./private/billingUpdates";
export { default as PostbillGuestLogin } from "../postBill/pages/public/postbillGuestLogin";
export { default as BillingCenterGuestLogin } from "../postBill/pages/public/billingCenterGuestLogin";
export { default as PostbillBillingCenter } from "../postBill/pages/private/billingCenter"; //TO DO is it the same page with the one above?
export { default as BillingHistoryStatements } from "../postBill/pages/private/billingHistoryStatements";
export { default as BillingHistoryPaymentPlans } from "../postBill/pages/private/billingHistoryPaymentPlans";
export { default as BillingHistoryPayments } from "../postBill/pages/private/billingHistoryPayments";
export { default as ReviewBills } from "../postBill/pages/private/reviewBills";
export { default as BillingPayment } from "../postBill/pages/private/billingPayment";
export { default as BillingFailure } from "../postBill/pages/private/billingPaymentFailure";
export { default as BillingConfirmation } from "../postBill/pages/private/billingPaymentConfirmation";
export { default as BillingPaymentPlanDetail } from "../postBill/pages/private/billingPaymentPlanDetail";
export { default as BillingUpdatePayment } from "../postBill/pages/private/billingUpdatePayment";
export { default as BillingPaymentSuccess } from "../postBill/pages/private/billingPaymentSuccess";
export {
  UPSGuestLoginPage,
  UPSUpdatePaymentMethodPage,
  UPSPaymentConfirmation,
  UPSReviewInvoice,
  UPSCreatePaymentMethod,
  UPSCreatePaymentConfirmation,
  UPSCreatePaymentFailure,
  UPSNoLongerAvailable,
  UPSReceipt,
} from "@app/ups/pages";
